export const replaceS3Url = url => {
    //   console.log('Original URL:', url);
    const baseUrl = 'https://files.prisms.in/';
    const replacementBaseUrl = 'https://s3.amazonaws.com/topschool-attachments/';
  
    const newUrl = url.replace(replacementBaseUrl, baseUrl);
    return newUrl;
  };